import { AuthConfig } from "angular-oauth2-oidc";

/**
 * OAuth 2.0 / OIDC configuration using the Duende Software demo identity provider.
 *
 * Demo server: https://demo.duendesoftware.com
 * Client: interactive.public
 */
export const authCodeFlowConfig: AuthConfig = {
	// Identity Provider discovery document URL
	issuer: "https://demo.duendesoftware.com",

	// Redirect after successful login
	redirectUri: window.location.origin + "/redirect",

	// Post-logout redirect
	postLogoutRedirectUri: "https://partikel-art.de",

	// Public PKCE client registered on demo.duendesoftware.com
	clientId: "interactive.public",

	responseType: "code",

	// Requested scopes
	scope: "openid profile email",

	// Setup endpoints manually based on Duende discovery document
	loginUrl: "https://demo.duendesoftware.com/connect/authorize",
	tokenEndpoint: "https://demo.duendesoftware.com/connect/token",
	userinfoEndpoint: "https://demo.duendesoftware.com/connect/userinfo",
	logoutUrl: "https://demo.duendesoftware.com/connect/endsession",
	revocationEndpoint: "https://demo.duendesoftware.com/connect/revocation",

	showDebugInformation: true,

	nonceStateSeparator: "semicolon",
};
